import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { EMPLOYEE_ROUTES } from './routes';
import { EmployeeDetailScreen } from '@/screens/restaurant/employee-detail-screen';
import { EmployeeNotificationsScreen } from '@/screens/restaurant/employee-notifications-screen';
import { EmployeeStackParams } from './types';
import { RestaurantEmployeesScreen } from '@/screens/restaurant/restaurant-employees-screen';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

const Stack = createStackNavigator<EmployeeStackParams>();

export const EmployeeStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={options}>
      <Stack.Screen
        component={RestaurantEmployeesScreen}
        name={EMPLOYEE_ROUTES.List}
      />
      <Stack.Screen
        component={EmployeeDetailScreen}
        name={EMPLOYEE_ROUTES.Detail}
      />
      <Stack.Screen
        component={EmployeeNotificationsScreen}
        name={EMPLOYEE_ROUTES.NotificationSettings}
      />
    </Stack.Navigator>
  );
};
